<div class="special-offer-preview-container">
    <div class="card preview-card" *ngIf="specialOffer">
        <div class="card-body d-flex flex-column gap-4">
            <div class="d-flex flex-column gap-3">
                <div class="d-flex justify-content-between">
                    <div HJSuppress class="fw-semibold fs-5 text-secondary">{{specialOffer.manufacturerName}}</div>
                    <div  HJSuppress *ngIf="specialOffer?.status !== SPECIAL_OFFER_STATUS.REQUESTED_OFFER"
                        class="status-badge"
                        [ngClass]="specialOffer.status.toLowerCase()">
                        {{"specialOffers.statusMessage."+specialOffer.status.toLowerCase() | translate}}
                    </div>
                </div>
                <div HJSuppress class="fw-semibold fs-2">{{ specialOffer.assetName}}</div>
                <div class="fs-5 fw-bold ">
                    <span HJSuppress class="text-primary">{{ specialOffer.assetPrice }} {{ specialOffer.currencyCode }}</span>
                    <span HJSuppress class="price-vat"> {{specialOffer.assetPriceWithVat
                            ? ('specialOffers.preview.information.withVAT' | translate)
                            : ('specialOffers.preview.information.withoutVAT' | translate)}}
                    </span>
                </div>
                <div class="date-item">
                    <span class="text-secondary">{{ 'specialOffers.preview.information.endDate' | translate }}</span>
                    <span HJSuppress class="text-danger fw-semibold"> {{ countdown$ | async }}</span>
                </div>
            </div>
            <div class="d-flex flex-wrap gap-4">
                <div class="dealer-box flex-grow-1 p-3">
                    <i class="app-icon icon icon-user icon-xxxl me-3 text-secondary"></i>
                    <div >
                        <span class="fw-semibold text-secondary">{{ 'specialOffers.preview.information.dealer' | translate }}</span>
                        <div HJSuppress class="fw-bold fs-5">{{ specialOffer.dealerName }}</div>
                    </div>
                </div>
                <div class="domain-box p-3">
                    <i class="app-icon icon icon-vehicle-request icon-xxxl me-3 text-secondary"></i>
                    <div >
                        <span class="fw-semibold text-secondary">{{ 'specialOffers.preview.information.industry' | translate }}</span>
                        <div HJSuppress class="fw-bold fs-5">{{ specialOffer.campaignType }}</div>
                    </div>
                </div>
            </div>
            <div class="image-container">
                <img
                    HJSuppress
                    *ngIf="specialOffer?.campaignImageSrc"
                    [src]="specialOffer.campaignImageSrc"
                    alt="Campaign product image"
                    class="img-fluid" />
            </div>
            <div class="financial-details flex-wrap">
                <div class="financial-item d-flex flex-column gap-2">
                    <span class="financial-label fw-semibold">{{ 'specialOffers.preview.information.downpayment' | translate }}</span>
                    <span HJSuppress class="financial-value fw-bold text-primary">{{ specialOffer.minimumDownPayment }} {{specialOffer.currencyCode}}</span>
                </div>
                <div class="financial-item d-flex flex-column gap-2">
                    <span class="financial-label fw-semibold ">{{ 'specialOffers.preview.information.interestRate' | translate }}</span>
                    <span HJSuppress class="financial-value fw-bold text-primary">{{ specialOffer.interest }} %</span>
                </div>
                <div class="financial-item d-flex flex-column gap-2">
                    <span class="financial-label fw-semibold">{{ 'specialOffers.preview.information.financingPeriod' | translate }}</span>
                    <span HJSuppress class="financial-value fw-bold text-primary">
                        {{ specialOffer.financingPeriod }}
                        {{ (specialOffer.financingPeriod === 1 ? 'specialOffers.wizard.financingDetails.month' : 'specialOffers.wizard.financingDetails.months') | translate }}
                    </span>
                </div>
                <div class="financial-item d-flex flex-column gap-2">
                    <span class="financial-label fw-semibold ">
                        {{'specialOffers.preview.information.monthlyInstallment' | translate }}</span>
                    <span HJSuppress class="financial-value fw-bold text-primary">
                        {{ specialOffer.estMonthlyInstallment }} {{specialOffer.currencyCode}}
                    </span>
                </div>
            </div>
            <div HJSuppress class="product-description-content">
                <span [innerHtml]="specialOffer.description"></span>
            </div>
        </div>
    </div>
    <div class="card request-document-card"
        *ngIf="specialOffer?.status !== SPECIAL_OFFER_STATUS.REQUESTED_OFFER">
        <preview-documents [specialOffer]="specialOffer"></preview-documents>
    </div>
    <div class="d-flex flex-column"
        *ngIf="specialOffer?.status !== SPECIAL_OFFER_STATUS.REQUESTED_OFFER">
        <div class="card request-offer-card">
            <div class="card-body">
                <div class="d-flex flex-column p-3 gap-4">
                    <button class="btn primary-btn"
                        (click)="sendOfferRequest(specialOffer.specialOfferId)" >
                        {{ 'specialOffers.preview.information.requestOffer' | translate }}
                        <i class="app-icon icon icon-chevron-right icon-lg"></i>
                    </button>
                    <div class="d-flex request-info gap-2 p-2">
                        <i class="app-icon icon icon-info-circle-fill icon-xxl text-secondary"></i>
                        <div>{{ 'specialOffers.preview.information.requestOfferInfo' | translate }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
